const routes = [
    {
        path: "/warnings",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission:'warning_index'
        }
    },
    {
        path: "/warning",
        component: () => import("../pages/Show.vue"),
        meta: {
            isAuthenticated: true,
        }
    }
];

export default routes;
